var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcardTheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 7H5.66667C3.91777 7 2.5 8.41776 2.5 10.1667V29.1667C2.5 30.9156 3.91777 32.3333 5.66667 32.3333H34.1667C35.9156 32.3333 37.3333 30.9156 37.3333 29.1667V10.1667C37.3333 8.41776 35.9156 7 34.1667 7Z",
    fill: "#9EA0FF",
    stroke: "#5A5CE7",
    strokeWidth: 3.27324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15L35.5 15",
    stroke: "#5A5CE7",
    strokeWidth: 4.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.12891,
    y: 19.6665,
    width: 10.9615,
    height: 5.11538,
    rx: 1.46154,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardTheme2);
export default __webpack_public_path__ + "static/media/creditcardTheme2.4a5009baa1040cb4d0212dd08023c06c.svg";
export { ForwardRef as ReactComponent };